export const EStorageKey = {
  SUBSCRIPTION_ID: 'subscription-id',
  PDL_NUMBER: 'pdl-number',
  IS_RESUBSCRIPTION: 'is-resubscription',
  CONTRACTOR_INFORMATIONS: 'contractor-informations',
} as const;
